@use "~theme/breakpoints";
@use "~theme/typography";

.columns {
  margin-top: 16px;

  // On desktop, 2 equally sized columns with a gap between.
  @include breakpoints.desktop {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: 28px;
  }
}

.list {
  margin: 0;
  padding: 0;
}

.item {
  margin-bottom: 24px;
}

.subheading {
  margin: 8px 0 24px;
}

.caption {
  @include typography.caption;
  color: var(--black-at-75);
  margin: 0;
}

.captionHeading {
  @include typography.caption-semibold;
  margin-bottom: 8px;
}
